import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { useAddBookMutation } from "../../features/api/apiSlice";
import CheckboxInput from "../UI/CheckboxInput";
import Error from "../UI/Error";
import TextInput from "../UI/TextInput";

const AddBookForm = () => {
  const [data, setData] = useState({
    name: "",
    author: "",
    thumbnail: "",
    price: "",
    rating: "",
    featured: false,
  });

  const [addBook, { isLoading, isError }] = useAddBookMutation();

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "checkbox") {
      setData({ ...data, featured: e.target.checked });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const resetForm = () => {
    setData({
      name: "",
      author: "",
      thumbnail: "",
      price: "",
      rating: "",
      featured: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await addBook(data);
    if (response.error) return;
    resetForm();
    navigate("/");
    toast.success("Book added successfully");
  };

  return (
    <form className="book-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <TextInput
          title="Book Name"
          identifier="bookName"
          inputType="text"
          name="name"
          value={data?.name}
          onChange={handleChange}
        />
      </div>

      <div className="space-y-2">
        <TextInput
          title="Author"
          identifier="author"
          inputType="text"
          name="author"
          value={data?.author}
          onChange={handleChange}
        />
      </div>

      <div className="space-y-2">
        <TextInput
          title="Image Url"
          identifier="thumbnail"
          inputType="text"
          name="thumbnail"
          value={data?.thumbnail}
          onChange={handleChange}
        />
      </div>

      <div className="grid grid-cols-2 gap-8 pb-4">
        <div className="space-y-2">
          <TextInput
            title="Price"
            identifier="price"
            inputType="number"
            name="price"
            value={data?.price}
            onChange={handleChange}
          />
        </div>

        <div className="space-y-2">
          <TextInput
            title="Rating"
            identifier="rating"
            inputType="number"
            name="rating"
            min="1"
            max="5"
            value={data?.rating}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="flex items-center">
        <CheckboxInput
          title="This is a featured book"
          identifier="featured"
          inputType="checkbox"
          name="featured"
          value={data?.featured}
          onChange={handleChange}
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="submit"
        id="lws-submit"
      >
        Add Book
      </button>

      {isError && <Error />}
    </form>
  );
};

export default AddBookForm;
